const PDV_DYNAMIC_RADIUS = {
  infos: {
    centerText: 'Raio Dinâmico',
  },
  howToWorkInfos: {
    title: 'COMO FUNCIONA?',
    content1:
      'É uma configuração automática que aumenta a área de entrega em alguns horários, para tentar atrair para sua Loja pedidos que estão deixando de ser atendidos na sua região.',
    buttonText: {
      testAccept: 'VER SUGESTÃO PARA ATIVAR',
      testDisable: 'JÁ ATIVEI, QUERO DESATIVAR',
    },
  },
  helpAndDoubtCard: {
    title: 'DÚVIDAS E AJUDA',
    content1: 'Por que ativar a configuração de raio dinâmico?',
    content2:
      'Sua loja pode receber mais pedidos nos momentos em que a área de entrega expandir.',
    content3: 'Como a área de entrega vai mudar?',
    content4:
      'Na maior parte do tempo sua Loja vai funcionar com a área de entrega normal, apenas no horário combinado o raio de entrega vai aumentar automaticamente, depois também no horário combinado volta para o tamanho normal.',
    buttonText: {
      doubtAndHelp: 'DÚVIDAS E AJUDA',
    },
  },
  faqModal: {
    title: 'DÚVIDAS E AJUDA',
    question1:
      'O raio dinâmico vai afetar o raio de entregas normal do meu ponto de venda?',
    answer1:
      'Apenas em horários combinados com você. Para a configuração do raio dinâmico ser ativada você precisa concordar clicando em "VER SUGESTÃO PARA ATIVAR" e preencher as informações solicitadas.',
    question2:
      'Vai aparecer algum aviso no Seu Zé quando a área de entrega aumentar? Como saber qual área a Loja está atendendo?',
    answer2:
      'Por enquanto não vai aparecer aviso no Seu Zé quando o raio de cobertura aumentar, mas é possível acessar "MINHA CONTA" e clicar em "Área de entrega" para conferir o tamanho da área que a Loja está atendendo.',
    question3:
      'Posso pedir para desativar o este a qualquer momento? Ou o Zé pode decidir encerrar a participação da Minha Loja neste teste?',
    answer3:
      'Depois de concordar em participar dos testes, se desejar você pode acessar "JÁ ATIVEI, QUERO DESATIVAR O RAIO" e aguardar o retorno do Zé confirmando que o teste foi desativado na sua Loja. O Time Zé também pode decidir desativar o teste, caso o aumento temporário da área de entrega afete negativamente nos indicadores de Operação do seu ponto de venda.',
    question4:
      'O valor do frete ou de incentivos operacionais vai mudar por causa do raio dinâmico?',
    answer4:
      'Os valores de frete e incentivos operacionais não vão mudar para os pedidos do raio dinâmico. Os pedidos que chegam no ponto de venda por conta do raio dinâmico incrementam entregas, onde o esforço para entrega de pedidos mais distantes do raio dinâmico compensa pelo menor esforço para entrega dos pedidos mais próximos do ponto de venda.',
    supportInfo:
      'Se precisar, peça ajuda sobre o raio dinâmico para o time do Zé.',
    buttonText: {
      helpAsk: 'SOLICITAR AJUDA',
    },
  },
  featureDiscoveryModal: {
    content1: 'Oportunidade para sua loja!',
    content2: 'Expansão automática e temporária da sua área de entrega',
    content3: 'Já conferiu essa novidade?',
    buttonText: {
      moreDetails: 'MAIS DETALHES',
    },
  },
  section: {
    title: 'Raio dinâmico',
    imageAlt: 'Ícone de Raio dinâmico',
    description: 'Área de entrega expandida em alguns horários.',
    actions: {
      showDetails: 'Ver Raio Dinâmico',
      howItWorks: 'Como funciona',
      details: 'Mais detalhes',
    },
  },
  modal: {
    title: 'Raio Dinâmico',
    subtitle: 'Dias e horários em que o raio é ligado na Loja:',
    info: 'Em todos os demais dias e horários a Loja opera com a área de entrega normal.',
    extraInfo:
      'Para desativar o Raio Dinâmico fale contato de relacionamento do Zé.',
  },
  offer: {
    banner: {
      title: {
        text1: 'Aumente',
        text2: 'a oportunidade de',
        text3: 'pedidos',
        text4: 'da sua loja',
        text5: 'com o raio dinâmico',
      },
      showDetails: 'Ver oportunidade',
    },
    modal: {
      detailsTabs: [
        {
          title: 'Oportunidade',
          subtitles: [
            'Clientes na sua região tentaram pedir no Zé e não encontraram uma loja.',
            'Expanda sua área de entrega e cubra essas oportunidades de pedidos.',
          ],
        },
        {
          title: 'Como vai funcionar',
          topics: [
            {
              title: 'Por que o Zé terá raio dinâmico a partir de agora?',
              paragraphs: [
                'O time do Zé identificou alguns consumidores tentam fazer um pedido e não encontram uma Loja, mas geralmente essas pessoas estão próximas de uma Loja, como a sua, que poderia atender o pedido.',
                'Assim foi desenvolvido uma solução que identifica as melhores Lojas para, de tempos em tempos, aumentar um pouco a área de entrega e atender esses Consumidores que deixariam de ser atendidos.',
              ],
            },
            {
              title: 'Por que ativar a configuração de raio dinâmico?',
              paragraphs: [
                'Sua loja pode receber mais pedidos nos momentos em que a área de entrega expandir.',
              ],
            },
            {
              title: 'Como a área de entrega vai mudar?',
              paragraphs: [
                'Na maior parte do tempo sua Loja vai funcionar com a área de entrega normal, apenas no horário combinado o raio de entrega vai aumentar automaticamente, depois também no horário combinado volta para o tamanho normal.',
              ],
            },
            {
              title:
                'O valor do frete ou de incentivos operacionais vai mudar por causa do raio dinâmico?',
              paragraphs: [
                'Os valores de frete e incentivos operacionais não vão mudar para os pedidos do raio dinâmico. Os pedidos que chegam no ponto de venda por conta do raio dinâmico incrementam entregas, onde o esforço para entrega de pedidos mais distantes do raio dinâmico compensa pelo menor esforço para entrega dos pedidos mais próximos do ponto de venda.',
              ],
            },
          ],
        },
      ],
      acceptScenario: {
        title: 'Configuração ativada!',
        subtitle: [
          'Você pode consultar dúvidas e as configurações do raio em ',
          '"Minha Conta"',
          ' dentro da "Área de Entrega".',
        ],
        successMessage: 'Sucesso! O Raio Dinâmico foi ativado.',
      },
      refuseScenario: {
        title: 'Porque você não quer ativar o raio dinâmico?',
        options: [
          'Não tenho disponibilidade de pessoas entregadoras nos horários ofertados',
          'Tenho dificuldade de manter o portifólio nesses horários',
          'Custo para manter a loja aberta é muito alto',
          'Não tenho pessoas suficientes para gerenciar a loja',
          'O raio dinâmico está cobrindo lugares perigosos ou difíceis de entregar',
          'Outros',
        ],
        errors: {
          invalidSize: 'Por favor, insira um motivo entre 10 e 100 caracteres',
          emptyOtherReason: 'Por favor, informe o motivo da recusa!',
        },
        successMessage: 'Sucesso! O Raio Dinâmico foi recusado.',
        otherReasonPlaceholder: 'Escreva...',
      },
      actions: {
        accept: 'Ativar',
        refuse: 'Não ativar',
      },
    },
    confirmModal: {
      accept: {
        title: 'Confirme que você está de acordo com a ativação',
        description:
          'Ao confirmar, o raio dinâmico passará a funcionar na sua loja nos horários e dias sugeridos. ',
      },
      refuse: {
        title: 'Você tem certeza que deseja recusar?',
        description:
          'Você não poderá ativar novamente até que uma nova oportunidade de raio dinâmico seja identificada para sua Loja.',
      },
    },
  },
  howItWorks: {
    title: 'Raio dinâmico - dúvidas e como funciona',
  },
}

export default PDV_DYNAMIC_RADIUS
